import React, { Component } from "react";
import "../../routes/app";
import withAuthorization from "../../components/Authorization/withAuthorization";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { fire, auth } from "../../firebase/index";
import MemberManagement from "../MemberManagement/MemberManagement";
import RecipientManagement from "../RecipientManagement/index";
import GroupManagement from "../GroupManagementNew/GroupManagementNew";
//? import chatbot
// import Chatbot from "../../views/Chatbot/Chatbot";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";

// import SettingManagement from "../SettingManagement/setting";
import { Button, Modal } from "react-bootstrap";
import { customLog } from "../../variables/Variables";
// import EditProfile from "../EditProfile/EditProfile";

//import subcomponents
// import { ResetPassword } from "./ResetPassword";
// import { SubscriptionManagement } from "./SubscriptionManagement";
// import { RedemptionManagement } from "./RedemptionManagement";
// import EditProfile from "../EditProfile/EditProfile";

//CSS
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    userManagementHeader: "User Management",
    memberManagementHeader: "All Members",
    recipientManagementHeader: "My Recipient List",
    groupManagementHeader: "My Group List",
    popUpTitle: "User Management Information",
    superAdminLabel: "Super Admin",
    superAdminExplanationTitle: "What is super admin?",
    superAdminExplanation:
      "A super admin is the owner of the subscription plan. Only a super admin is able to modify the subscription plan & add members. A super admin is also able to perform admin & user's functions.",
    superAdminLabel1: "1. Subscription plan",
    superAdminLabel2: "2. Add/Remove members",
    superAdminLabel3: "3. Assign roles (admin or user)",
    superAdminLabel4: "4. Admin member's function",
    superAdminLabel5: "5. User's functions",
    AdminLabel: "Admin",
    AdminLabel1: "1. Add/Remove locks",
    AdminLabel2: "2. Select recipients",
    AdminLabel3: "3. View/Edit access (grant & revoke)",
    AdminLabel4: "4. View/Edit audit trails",
    AdminLabel5: "5. User's functions",
    AdminExplanationTitle: "What is admin?",
    AdminExplanation:
      "An admin is a member assigned admin role by the super admin. Admin is able to add, remove, manage locks, select recipients, view, edit & manage access.",
    RecipientUsersLabel: "Recipient/Members",
    RecipientUsersLabel1: "1. Lock & unlock with mobile app",
    RecipientExplanationTitle: "What is recipient?",
    RecipientExplanation:
      "A recipient is a selected member with user role that is chosen/added by an admin member to be managed. A recipient/user may only lock & unlock using mobile app.",
    MemberExplanationTitle: "What is member?",
    MemberExplanation:
      "A member is a registered user to be your subscription account. A member can be assigned an admin role or a user role.",
  },
  ja: {
    userManagementHeader: "メンバー管理",
    memberManagementHeader: "全メンバー",
    recipientManagementHeader: "登録リスト",
    groupManagementHeader: "グループ",
    popUpTitle: "ユーザー管理情報",
    superAdminLabel: "スーパー管理者",
    superAdminExplanationTitle: "スーパー管理者とは？",
    superAdminExplanation:
      "スーパー管理者はサブスクリプションプランの所有者です。スーパー管理者だけがサブスクリプションプランを変更し、メンバーを追加できます。スーパー管理者は管理者とユーザーの機能を実行することもできます。",
    superAdminLabel1: "1. サブスクリプションプラン",
    superAdminLabel2: "2. メンバーの追加/削除",
    superAdminLabel3: "3. 役割の割り当て（管理者またはユーザー）",
    superAdminLabel4: "4. 管理者メンバーの機能",
    superAdminLabel5: "5. ユーザーの機能",
    AdminLabel: "管理者",
    AdminLabel1: "1. ロックの追加/削除",
    AdminLabel2: "2. 受信者の選択",
    AdminLabel3: "3. アクセスの表示/編集（付与と取り消し）",
    AdminLabel4: "4. 監査履歴の表示/編集",
    AdminLabel5: "5. ユーザーの機能",
    AdminExplanationTitle: "管理者とは？",
    AdminExplanation:
      "管理者は、スーパー管理者によって管理者の役割を割り当てられたメンバーです。管理者はロックの追加、削除、管理、受信者の選択、アクセスの表示、編集、および管理が可能です。",
    RecipientUsersLabel: "受信者/メンバー",
    RecipientUsersLabel1: "1. モバイルアプリでロックとアンロックを行う",
    RecipientExplanationTitle: "受信者とは？",
    RecipientExplanation:
      "受信者は、管理者メンバーによって選択/追加されたユーザーの役割を持つメンバーです。受信者/ユーザーは、モバイルアプリを使用してのみロックとアンロックを行うことができます。",
    MemberExplanationTitle: "メンバーとは？",
    MemberExplanation:
      "メンバーは、サブスクリプションアカウントに登録されたユーザーです。メンバーには管理者の役割やユーザーの役割を割り当てることができます。",
  },
  es: {
    userManagementHeader: "Gestión de Usuarios",
    memberManagementHeader: "Todos los Miembros",
    recipientManagementHeader: "Mi Lista de Destinatarios",
    groupManagementHeader: "Mi Lista de Grupos",
    popUpTitle: "Información de Gestión de Usuarios",
    superAdminLabel: "Super Admin",
    superAdminExplanationTitle: "¿Qué es un Super Admin?",
    superAdminExplanation:
      "Un Super Admin es el propietario del plan de suscripción. Solo un Super Admin puede modificar el plan de suscripción y agregar miembros. Un Super Admin también puede realizar las funciones de administrador y de usuario.",
    superAdminLabel1: "1. Plan de suscripción",
    superAdminLabel2: "2. Agregar/Eliminar miembros",
    superAdminLabel3: "3. Asignar roles (administrador o usuario)",
    superAdminLabel4: "4. Función de miembro administrador",
    superAdminLabel5: "5. Funciones de usuario",
    AdminLabel: "Admin",
    AdminLabel1: "1. Agregar/Eliminar candados",
    AdminLabel2: "2. Seleccionar destinatarios",
    AdminLabel3: "3. Ver/Editar acceso (otorgar y revocar)",
    AdminLabel4: "4. Ver/Editar registros de auditoría",
    AdminLabel5: "5. Funciones de usuario",
    AdminExplanationTitle: "¿Qué es un Admin?",
    AdminExplanation:
      "Un Admin es un miembro asignado con el rol de administrador por el Super Admin. Un Admin puede agregar, eliminar, gestionar candados, seleccionar destinatarios, ver, editar y gestionar el acceso.",
    RecipientUsersLabel: "Destinatarios/Miembros",
    RecipientUsersLabel1: "1. Bloquear y desbloquear con la aplicación móvil",
    RecipientExplanationTitle: "¿Qué es un destinatario?",
    RecipientExplanation:
      "Un destinatario es un miembro seleccionado con el rol de usuario que ha sido elegido/agregado por un miembro administrador para ser gestionado. Un destinatario/usuario solo puede bloquear y desbloquear usando la aplicación móvil.",
    MemberExplanationTitle: "¿Qué es un miembro?",
    MemberExplanation:
      "Un miembro es un usuario registrado en tu cuenta de suscripción. Un miembro puede ser asignado con un rol de administrador o de usuario.",
  },
});

class UserManagement extends Component {
  constructor(props) {
    super(props);
    // this.currentpasswordChange = this.currentpasswordChange.bind(this);

    this.state = {
      isPaymentValid: false,
      isAdmin: false,
      isSuperAdmin: false,
      currentLanguage: localizationStrings.getLanguage(),
      showPopupInfo: false,
    };

    this.handleInsertButtonClick = this.handleInsertButtonClick.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  componentDidMount() {
    const groupAccountsDB = fire.database().ref("groupAccounts");

    groupAccountsDB.once("value").then((snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((eachSuperAdmin) => {
          const superAdminDetails = eachSuperAdmin.val();
          // const superAdminId = eachSuperAdmin.key;
          const members = superAdminDetails.members;

          for (const eachMembers in members) {
            const memberDetails = members[eachMembers];
            if (memberDetails.memberEmail === auth.currentUser.email) {
              const paymentDetails = superAdminDetails.payment.isPaymentValid;
              this.setState({
                isAdmin: memberDetails.isAdmin,
                isSuperAdmin: memberDetails.isSuperAdmin,
                isPaymentValid: paymentDetails,
              });
            }
          }
        });
        // this.setState({ isPaymentValid: snapshotVal.isPaymentValid });
      }
    });
  }

  handleInsertButtonClick() {
    this.setState({
      showPopupInfo: true,
    });
  }

  handlePopupClose() {
    this.setState({
      showPopupInfo: false,
    });
  }

  getUserId = async (email) => {
    const url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserByEmail";

    let userId = "";

    await fetch(url, {
      method: "POST",
      body: JSON.stringify({ email: email }),
    }).then(async (response) => {
      const responseResult = await response.json();
      userId = responseResult.uid;
    });

    return userId;
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div
        style={{
          width: "95%",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "40px",
          marginTop: "30px",
        }}
      >
        <div className="header">
          <h2 style={{ display: "inline", marginRight: "10px" }}>
            {localizationStrings.userManagementHeader}
          </h2>
          <button
            style={{
              color: "#3C3E41",
              fontSize: "24px",
              backgroundColor: "transparent",
              cursor: "pointer",
              border: "none", // Set border to none to remove it
              padding: 0, // Remove padding to avoid extra space
            }}
            onClick={this.handleInsertButtonClick}
          >
            <span
              className="glyphicon glyphicon-info-sign"
              aria-hidden="true"
              style={{ marginLeft: "10px" }}
            ></span>
          </button>
          <Modal
            show={this.state.showPopupInfo}
            onHide={this.handlePopupClose}
            dialogClassName="modal-70w"
          >
            <Modal.Header closeButton>
              <Modal.Title>{localizationStrings.popUpTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
              <div className="selectMembersTable">
                <div style={{ fontSize: "1.5em" }}>
                  {localizationStrings.superAdminLabel}
                </div>
                <br />
                <div className={"dropDownInput"} style={{ fontSize: "15px" }}>
                  {localizationStrings.superAdminLabel1}
                  <br />
                  {localizationStrings.superAdminLabel2}
                  <br />
                  {localizationStrings.superAdminLabel3}
                  <br />
                  {localizationStrings.superAdminLabel4}
                  <br />
                  {localizationStrings.superAdminLabel5}
                </div>
              </div>
              <br />
              <div style={{ fontSize: "1.5em" }}>
                {localizationStrings.superAdminExplanationTitle}
              </div>
              <br />
              <div className={"dropDownInput"} style={{ fontSize: "15px" }}>
                {localizationStrings.superAdminExplanation}
              </div>
              <br />
              <div style={{ fontSize: "1.5em" }}>
                {localizationStrings.AdminLabel}
              </div>
              <br />
              <div className={"dropDownInput"} style={{ fontSize: "15px" }}>
                {localizationStrings.AdminLabel1}
                <br />
                {localizationStrings.AdminLabel2}
                <br />
                {localizationStrings.AdminLabel3}
                <br />
                {localizationStrings.AdminLabel4}
                <br />
                {localizationStrings.AdminLabel5}
              </div>
              <br />
              <div style={{ fontSize: "1.5em" }}>
                {localizationStrings.AdminExplanationTitle}
              </div>
              <br />
              <div className={"dropDownInput"} style={{ fontSize: "15px" }}>
                {localizationStrings.AdminExplanation}
              </div>
              <br />
              <div style={{ fontSize: "1.5em" }}>
                {localizationStrings.RecipientUsersLabel}
              </div>
              <br />
              <div className={"dropDownInput"} style={{ fontSize: "15px" }}>
                {localizationStrings.RecipientUsersLabel1}
                <br />
              </div>
              <br />
              <div style={{ fontSize: "1.5em" }}>
                {localizationStrings.RecipientExplanationTitle}
              </div>
              <br />
              <div className={"dropDownInput"} style={{ fontSize: "15px" }}>
                {localizationStrings.RecipientExplanation}
              </div>
              <br />
              <div style={{ fontSize: "1.5em" }}>
                {localizationStrings.MemberExplanationTitle}
              </div>
              <br />
              <div className={"dropDownInput"} style={{ fontSize: "15px" }}>
                {localizationStrings.MemberExplanation}
              </div>
            </Modal.Body>
          </Modal>
        </div>
        <br />

        <Tabs defaultIndex={0}>
          <TabList>
            {this.state.isPaymentValid &&
            (this.state.isAdmin || this.state.isSuperAdmin) ? (
              <Tab>{localizationStrings.memberManagementHeader}</Tab>
            ) : (
              <Tab disabled>{localizationStrings.memberManagementHeader}</Tab>
            )}

            <Tab>{localizationStrings.recipientManagementHeader}</Tab>

            <Tab>{localizationStrings.groupManagementHeader}</Tab>
          </TabList>

          <TabPanel>
            <MemberManagement />
          </TabPanel>

          <TabPanel>
            <RecipientManagement />
          </TabPanel>

          <TabPanel>
            <GroupManagement />
          </TabPanel>

          {/* <TabPanel>
            <ResetPassword />
          </TabPanel> */}

          {/* <TabPanel>
            <SubscriptionManagement />
          </TabPanel>
          <TabPanel>
            <RedemptionManagement />
          </TabPanel> */}
        </Tabs>
        <div className="empty-space"></div>
        {/* <Chatbot/> */}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(UserManagement);
